import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, ScoreType, Window508Type } from "../CalmBaseScenario";
import Scenario3 from "./Scenario3";

export default class Scenario3Part1 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 0;
	private checkedManual : boolean;
	
	chapterIds = {
		scenario3_1a_s1: 'CALM - Scenario 3 - 1A - Segment 1', //a.	Heather has vest question - to Respond UI
		scenario3_1a_s2: 'CALM - Scenario 3 - 1A - Segment 2', //a.	Heather & CN go to PC - to PC UI
		scenario3_1a_s3: 'CALM - Scenario 3 - 1A - Segment 3', //a.	Heather doesn’t understand - to Respond UI
		scenario3_1a_s3a: 'CALM - Scenario 3 - 1A - Segment 3a', // CN Calls BEN, Heather leaves and CN turns back to PC - to computer UI << added 5/2/2022
		scenario3_1a_s4: 'CALM - Scenario 3 - 1A - Segment 4' //a.	CN calls BEN, Heather leaves and CN goes to PC -  to Computer Report UI
	}

	constructor(scenario: Scenario3, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario3/calm-scenario3-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario3.parts.level3Part1.id;
	}

	public start() {
		const context = this;
		this.scenario.displayBeginScenarioUI(
			'./assets/images/scenario3/begin-scenario-scenario3.jpg',
			'calm-scenario3-begin-scenario',
			() => {
				this.scenario.playAmbientLoop(this.scenario.audioHall);
				context.segment1Step1HeatherApproaches();
			});
	}

	private segment1Step1HeatherApproaches() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.displayHeader();
		context.playVideoChapter(this.chapterIds.scenario3_1a_s1, () =>
			context.segment1Step2Dialogue())
	}

	private segment1Step2Dialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		var researchVestResponse = "Let\’s research the vest. I will pull up the vest\’s user manual and see if I can quickly learn how to operate it."
		this.scenario.dialog(
			'CN-C12-L2-000a',
			[{
				text: researchVestResponse,
				scoreType: ScoreType.Ok,
				isCorrect: false // Rank okay
			}, {
				text: 'Go ahead and switch him to one of our defibrillators that our staff is more familiar with.',
				feedback: 'The physician at the hospital that this patient was transferred from has specifically requested that he remain on the defibrillator vest for a reason. The physician is worried that an acute arrhythmia may occur at any time, leading to cardiac arrest. The vest must stay.',
				scoreType: ScoreType.Worst,
				isCorrect: false // Rank worst
			}, {
				text: 'Maybe our facility has some training on defibrillator vests. I’ll check',
				feedback: 'Normally, looking up staff training on a topic would be an excellent idea. However, even if your facility had training on this particular vest, training materials are often time-consuming, and this situation is very time-sensitive. Your staff needs to understand the basics of this vest immediately.',
				scoreType: ScoreType.Worst,
				isCorrect: false
			}, {
				text: 'I’ll call the manufacturer’s hotline. Maybe someone can explain how to best use the vest.',
				scoreType: ScoreType.Best,
				isCorrect: true
			}],
			(selectedOption: DialogueUIOptionConfig) => {
				selectedOption.hide = true; // set hide here
				if (selectedOption.text.indexOf(researchVestResponse) !== -1) {
					context.segment2aStep1ResearchOptionStart();
				}
				else {
					if(this.checkedManual){
					context.scenario.evaluateAnswer(selectedOption, () => context.segment3Step1CallManufacturorAtPC(), context.partIndx);
					} else {
						context.scenario.evaluateAnswer(selectedOption, () => context.segment3Step1CallManufacturor(), context.partIndx);
					}
				}
			}
		);
	}

	private segment2aStep1ResearchOptionStart() {
		var context = this;
		this.checkedManual = true;
		context.scenario.gameManager.UiManager.hideAllUis([]);
		context.playVideoChapter(context.chapterIds.scenario3_1a_s2, () => {
			context.segment2aStep2ComputerResearch();
		});
	}

	private segment2aStep2ComputerResearch() { // This interaction is just a scrollable text field with text		
		var context = this;
		context.scenario.update508Window(Window508Type.NurseStationComputerUI);
		const instanceId = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerUI, {
			reports: null,
			review: { 
				text:
					`
					<p class="regular-description-font" style="margin: 0">
						
						Defibrillator Vest Manual</span><br /><br />

						<span style="color: rgb(222, 225, 156)">Like an implanted device, an external defibrillator continuously monitors a patient’s heart rate and delivers a shock when it senses a life-threatening arrhythmia. <br /><br />

						<span style="color: rgb(222, 225, 156)">
						(1) Non-adhesive sensing electrodes around the torso continuously monitor the heart rate. <br /><br />

						(2) A monitor holstered at the waist collects data from the electrodes that can be uploaded and recorded to a computer. If an arrhythmia is detected, the module alerts the patient with an audible, visual or vibrating alarm. If a shock is not necessary, the alert can be disarmed by the patient. <br /><br />

						(3) In case of a life-threatening arrhythmia, therapeutic electrodes on the back of the vest will apply a conductive gel before a shock is delivered.</span>
					</p>
					`
			},
			reflects: null,
			onClosed: (config: NurseStationComputerUIConfig) => {
				context.scenario.update508Window(Window508Type.Main);
				context.scenario.gameManager.UiManager.destroyUIInstanceById(instanceId);
				context.segment2bStep1ResearchOptionEnd();
			}
		})
	}

	private segment2bStep1ResearchOptionEnd() {
		var context = this;
		context.playVideoChapter(context.chapterIds.scenario3_1a_s3, () => {			
			context.scenario.gameManager.UiManager.showAllUis([]);
		});
	}


	private segment3Step1CallManufacturor() {
		this.scenario.destroyAllUIInstances();
		var context = this;		
		context.scenario.updateObjective('Call the manufacturor');
		context.playVideoChapter(this.chapterIds.scenario3_1a_s4, () => {
			context.scenario.updateObjective('Enter Reports at the Nurse Station Computer');
			context.segment4Step1NSCReports();				
		});
	}

	private segment3Step1CallManufacturorAtPC() {
		this.scenario.destroyAllUIInstances();
		var context = this;		
		context.scenario.updateObjective('Call the manufacturor');
		context.playVideoChapter(this.chapterIds.scenario3_1a_s3a, () => {
			context.scenario.updateObjective('Enter Reports at the Nurse Station Computer');
			context.segment4Step1NSCReports();				
		});
	}

	private segment4Step1NSCReports() {
		var context = this;
		context.scenario.update508Window(Window508Type.NurseStationComputerUI);
		context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerUI, {
			reports: [
				{
					title: 'Incident',
					description: 'Nothing to add to report'
				},
				{
					title: '24 Hour',
					description: 'This was added to the report: Patient arrived wearing defibrillator vest that was unfamiliar to staff. A Quick Guide was obtained from the manufacturer for staff usage. Implement just-in-time training. Determine if this piece of equipment is going to be continually used in this facility.'
				},
				{
					title: 'End of Shift',
					description: 'This was added to the report: Patient arrived wearing defibrillator vest that was unfamiliar to staff. A Quick Guide was obtained from the manufacturer for staff usage. Implement just-in-time training. Determine if this piece of equipment is going to be continually used in this facility.'
				}
			],
			review: {
				text:
					`
				<p class="regular-description-font" style="margin: 0">
					In this scenario, staff were not knowledgeable on a new piece of equipment that arrived. While the patient transfer communication indicated 
					the patient would be on a defibrillator, it was not specified what kind.<br /><br />

					A Charge Nurse needs to make sure that <span style="color: rgb(222, 225, 156)">all needed details about newly admitted and transferred patients are known, well before they reach the 
					unit floor</span>. In this manner, available training can be efficiently acquired. <br /><br />

					In this scenario, any existing training would likely not be timely and the <span style="color: rgb(222, 225, 156)">knowledge was needed now</span>. <br /><br />
					
					So remember, <span style="color: rgb(222, 225, 156)">you can often find manufacturer contact information directly on the equipment for immediate support.</span> Fortunately, in this scenario, the manufacturer was able to provide a Quick Guide for immediate use.  <br /><br />
					
					It is the Charge Nurse\'s responsibility to <span style="color: rgb(222, 225, 156)"> ensure staff were educated on how to use this piece of equipment</span>.
				</p>
				`
			},
			reflects: [
				{
					title: 'What training resources are available to you when a new piece of equipment arrives?',
					answer: ''
				},
				{
					title: 'How do you rapidly determine the operational requirements of new equipment?',
					answer: ''
				},
				{
					title: 'Does your facility offer training on new pieces of equipment?',
					answer: ''
				},
				{
					title: 'Who creates or provides new equipment training at your facility?',
					answer: ''
				}
			],
			onClosed: (config: NurseStationComputerUIConfig) => {
				context.scenario.update508Window(Window508Type.Main);
				context.partEnd();
			}
		})
	}

	private partEnd() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.gameManager.customData.saveData.scenarios[this.scenario.currentLevel].badges[context.partIndx].points = CalmBaseScenario.scores[this.partIndx];

		this.scenario.gameManager.customData.saveData.scenarios[this.scenario.currentLevel].badges[context.partIndx].isUnlocked = true;
		this.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = this.partId;

		this.scenario.gameManager.customData.saveGame(this.scenario.gameManager);

		this.scenario.showBadgingUI(context.partIndx, () => {
			context.onDone();
		});
	}
}